import GrpcService, { PlatformAdminApi } from 'src/services/GrpcService';

import {
  ICreate,
  ISearch,
  IUpdate,
  IRestore,
  IFindById,
  IRemove,
} from 'src/services/ServiceLocator/ServiceLocator.interface';
import { RequestController } from 'src/utils/decorators/request-controller';

class PersonServiceProvider implements ISearch, ICreate, IUpdate, IRestore, IFindById, IRemove {
  @RequestController({ logger: true, retry: true, debounce: true })
  search(params: PlatformAdminApi.ISearchPersonRequest): Promise<PlatformAdminApi.SearchPersonResponse> {
    return GrpcService.CRMPersonService.SearchPerson(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  create(params: PlatformAdminApi.ICreatePersonRequest): Promise<PlatformAdminApi.PersonResponse> {
    return GrpcService.CRMPersonService.Create(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  update(params: PlatformAdminApi.IUpdatePersonRequest): Promise<PlatformAdminApi.PersonResponse> {
    return GrpcService.CRMPersonService.Update(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  restore(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.PersonResponse> {
    return GrpcService.CRMPersonService.Restore(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  remove(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.PersonResponse> {
    return GrpcService.CRMPersonService.Remove(params);
  }

  @RequestController({ logger: true, retry: true, debounce: true })
  findById(params: PlatformAdminApi.IUuidRequest): Promise<PlatformAdminApi.PersonResponse> {
    return GrpcService.CRMPersonService.FindById(params);
  }
}

export const personServiceProvider = new PersonServiceProvider();
export type TPersonServiceProvider = typeof personServiceProvider;
